<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open">
  <div class="esf-main-sidebar__content">
    <h3><span i18n='Club data edit modal title@@clubComponent.workspaceTitle.editWebsiteSettings'>Edit website settings</span></h3>
    <form [formGroup]="clubForm" (ngSubmit)="updateClub()" id="editWebsiteSettings">
      <div app-form-field-text-generic
           [control]="clubForm.get('title')"
           [placeholder]="flTranslations.i18nTitle"
           [label]="flTranslations.i18nTitle">
      </div>
      <div class="esf-form-group">
        <div app-form-field-color-picker
             class="esf-form-item--1-2"
             [control]="clubForm.get('headerColor')"
             [label]="flTranslations.i18nHeaderColor">
        </div>
        <div app-form-field-color-picker
             class="esf-form-item--1-2"
             [control]="clubForm.get('footerColor')"
             [label]="flTranslations.i18nFooterColor">
        </div>
      </div>
      <div app-form-field-color-picker
             [control]="clubForm.get('buttonColor')"
             [label]="flTranslations.i18nButtonColor">
        </div>
      <div app-form-field-text-generic
           [control]="clubForm.get('links.imprint')"
           [placeholder]="flTranslations.i18nImprintUrl"
           [label]="flTranslations.i18nImprintUrl">
      </div>
      <div app-form-field-text-generic
           [control]="clubForm.get('links.dataPrivacy')"
           [placeholder]="flTranslations.i18nDataPrivacyUrl"
           [label]="flTranslations.i18nDataPrivacyUrl">
      </div>
      <div app-form-field-text-generic
           [control]="clubForm.get('links.toc')"
           [placeholder]="flTranslations.i18nTocUrl"
           [label]="flTranslations.i18nTocUrl">
      </div>
      <div app-form-field-text-generic
           [control]="clubForm.get('links.accountManagement')"
           [placeholder]="flTranslations.i18nAccountManagementUrl"
           [label]="flTranslations.i18nAccountManagementUrl">
      </div>
      <div app-form-field-text-generic
           [control]="clubForm.get('links.ssoLogout')"
           [placeholder]="flTranslations.i18nSsoLogoutUrl"
           [label]="flTranslations.i18nSsoLogoutUrl">
      </div>
      <div app-form-field-text-generic
           [control]="clubForm.get('links.progressiveProfiling')"
           [placeholder]="flTranslations.i18nProgressiveProfilingUrl"
           [label]="flTranslations.i18nProgressiveProfilingUrl">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
  <app-submit-row-buttons [form]="'editWebsiteSettings'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="clubOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open"
     (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
